module.exports = __webpack_public_path__ + "static/media/front.12768105.jpg";